import { useMemo } from 'react';

import type {
  DispatchProps,
  StateProps,
} from '../containers/transferToAgentModal';
import { useTransferAgents } from '../hooks/useTransferAgents';
import { rankSearchMember } from '../utils/rankSearchMember';

import { TransferPresenceLiveUpdates } from './transferPresenceLiveUpdates';
import TransferToAgentModal from './transferToAgentModal';

type TransferToAgentModalWrapperProps = StateProps & DispatchProps;

export function TransferToAgentModalWrapper(
  props: TransferToAgentModalWrapperProps,
): JSX.Element {
  const { queueId, profile, ui, ...restProps } = props;
  const isModalShown = ui.isModalShown;

  const { members, isLoading } = useTransferAgents(isModalShown, queueId);

  const sortedMembers = useMemo(
    () =>
      [...members].sort((a, b) => {
        const rankDiff = rankSearchMember(a) - rankSearchMember(b);
        if (rankDiff !== 0) return rankDiff;
        return (a.name ?? '')
          .toLowerCase()
          .localeCompare((b.name ?? '').toLowerCase());
      }),
    [members],
  );

  return (
    <>
      {isModalShown && <TransferPresenceLiveUpdates />}
      <TransferToAgentModal
        {...restProps}
        ui={ui}
        profile={profile}
        queueId={queueId}
        onlineMembers={sortedMembers}
        isLoadingMembers={isLoading}
      />
    </>
  );
}
